var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDesktop)?_c('div',{class:[_vm.$style.container, _vm.pageIsMenu && _vm.$style.open]},[_c('VMenu',{class:[_vm.$style.menu, _vm.pageIsMenu && _vm.$style.menuOpen],attrs:{"desktop":""}}),_c('AppRightSectionBurger',{class:_vm.isBurgerHidden && _vm.$style.hidden}),_c('AppRightSectionFooter')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }